import {moduleNamespace} from './constants';
import {getItemFromSession, writeSession} from "../../sharedGlobal";

/**
 * Get and decode the JSON encoded form fields from session.
 */
export function formFieldFromSession(field) {
  const formFields = JSON.parse(
    getItemFromSession(moduleNamespace, 'formFields')
  );
  return formFields === null ? null : formFields[field];
}

/**
 * Get and decode the JSON encoded registration form data from session.
 * TODO: Investigate why this isn't utilised?
 */
export function registrationFieldsFromSession(field) {
  const registrationFields = JSON.parse(
    getItemFromSession(moduleNamespace, 'registrationFields')
  );
  return registrationFields === null ? null : registrationFields[field];
}

/**
 * JSON encode and write the user-configured registration page data to session.
 */
export function writeRegistrationToSession(registration) {
  writeSession(
    moduleNamespace,
    'registration',
    JSON.stringify(registration)
  );
}

/**
 * JSON encode and write the user-configured tax information data to session.
 */
export function writeTaxConfigToSession(registration) {
  writeSession(
    moduleNamespace,
    'taxConfig',
    JSON.stringify(registration)
  );
}
